import { render, staticRenderFns } from "./CardRelatedItems.vue?vue&type=template&id=172785f8&scoped=true"
import script from "./CardRelatedItems.vue?vue&type=script&lang=js"
export * from "./CardRelatedItems.vue?vue&type=script&lang=js"
import style0 from "./CardRelatedItems.vue?vue&type=style&index=0&id=172785f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172785f8",
  null
  
)

export default component.exports